import { Link } from "react-router-dom";
import { SERVICES } from "../data/content";

export const ServicesMarquee = () => {
  const items = [...SERVICES, ...SERVICES];
  return (
    <div
      className="marquee relative bg-navy bg-grain overflow-hidden border-y border-white/10"
      data-testid="services-marquee"
      aria-label="Unsere Leistungen im Überblick"
    >
      <div className="marquee-track flex w-max items-center py-5 md:py-6">
        {items.map((s, i) => (
          <Link
            key={`${s.id}-${i}`}
            to="/leistungen"
            data-testid={`marquee-item-${i}`}
            className="group flex items-center gap-6 md:gap-8 px-6 md:px-8 py-2.5 shrink-0"
            tabIndex={i < SERVICES.length ? 0 : -1}
            aria-hidden={i >= SERVICES.length}
          >
            <span className="font-display text-lg md:text-2xl font-semibold tracking-tight text-white/85 whitespace-nowrap transition-colors duration-300 group-hover:text-herald">
              {s.title}
            </span>
            <span
              className="w-2.5 h-2.5 rotate-45 bg-herald/70 shrink-0 transition-transform duration-500 group-hover:rotate-[225deg]"
              aria-hidden="true"
            />
          </Link>
        ))}
      </div>
    </div>
  );
};
